import {
  Route,
  Navigate,
  Routes
} from 'react-router-dom'
import Login from "./Pages/Auto/Login/Login";
import Register from "./Pages/Auto/Register/Register";
import Home from "./Pages/Home/Home";
import Layout from "./Components/Layout/Layout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from 'react-redux';
import Venues from './Pages/Venues/Venues';

function App() {
  const isProfileData = useSelector(state => state.isProfileData)
  console.log("isProfileData",isProfileData);
  

  return (
    <div>
      {isProfileData ?
        <Layout>
          <Routes>
            <Route
              path="/dashboard"
              element={<Home />}
            />

            <Route
              path="/venues"
              element={<Venues />}
            />
            
          </Routes>
        </Layout> :
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      }

      <ToastContainer position="top-right" autoClose={3000} theme="dark" />
    </div>
  );
}

export default App;
